module.exports = __webpack_public_path__ + "img/team.b222418b.jpg";